import PropTypes from 'prop-types';
import { Box, Typography, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import CountUp from 'react-countup';
import { scaleIn } from '../utils/dashboardUtils';

const KpiCard = ({ icon: Icon, label, value, subtitle, color, index }) => (
    <motion.div
        custom={index}
        variants={scaleIn}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
        style={{ height: '100%' }}
    >
        <Paper
            elevation={0}
            sx={{
                height: '100%',
                p: 3,
                borderRadius: 3,
                border: '1px solid',
                borderColor: 'divider',
                position: 'relative',
                overflow: 'hidden',
                transition: 'transform 0.2s, box-shadow 0.2s',
                '&:hover': { transform: 'translateY(-3px)', boxShadow: '0 8px 30px rgba(0,0,0,0.10)' }
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: -20,
                    right: -20,
                    width: 100,
                    height: 100,
                    borderRadius: '50%',
                    bgcolor: color,
                    opacity: 0.08
                }}
            />
            <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                <Box>
                    <Typography
                        variant="caption"
                        color="text.secondary"
                        fontWeight={600}
                        sx={{ textTransform: 'uppercase', letterSpacing: '0.05em' }}
                    >
                        {label}
                    </Typography>
                    <Typography variant="h3" fontWeight={800} sx={{ my: 0.5, color }}>
                        <CountUp end={value} duration={1.6} />
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        {subtitle}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        width: 48,
                        height: 48,
                        borderRadius: 2,
                        bgcolor: color,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        opacity: 0.9
                    }}
                >
                    <Icon sx={{ color: '#fff', fontSize: 24 }} />
                </Box>
            </Box>
        </Paper>
    </motion.div>
);

KpiCard.propTypes = {
    icon: PropTypes.elementType.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    subtitle: PropTypes.string,
    color: PropTypes.string,
    index: PropTypes.number
};

export default KpiCard;
